module.exports = __webpack_public_path__ + "static/media/public-hero.aa6e76bf.jpg";